export enum AccountTypes {
  preActive = 'PRE_ACTIVE',
  active = 'ACTIVE',
  grace = 'GRACE',
  postGrace = 'POST_GRACE',
  recycle = 'RECYCLE',
}
